module.exports = __webpack_public_path__ + "static/media/GreenBookAcademy.Logo.e456ef09.png";